import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Book from "@/pages/Book";
import Confirmation from "@/pages/Confirmation";
import Login from "@/pages/Login";
import OwnerDashboard from "@/pages/OwnerDashboard";
import EmployeeJobs from "@/pages/EmployeeJobs";

const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-4 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "owner" ? "/dashboard" : "/jobs"} replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    document.title = "Blake's Mowing & Odd Jobs | Cooma";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/book" element={<Book />} />
            <Route path="/book/confirmation/:id" element={<Confirmation />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Protected roles={["owner"]}><OwnerDashboard /></Protected>} />
            <Route path="/jobs" element={<Protected roles={["employee", "owner"]}><EmployeeJobs /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
